import { createContext } from 'react'

import { CashRequestMiddleware, CashResponseMiddleware } from './types'

export type OptionalMiddlewareRequest = (middleware: CashRequestMiddleware[]) => CashRequestMiddleware[]
export type OptionalMiddlewareResponse = (middleware: CashResponseMiddleware[]) => CashResponseMiddleware[]

export type OptionalMiddlewareContextProps = {
  [name: string]: {
    response?: OptionalMiddlewareResponse
    request?: OptionalMiddlewareRequest
  }
}

export const OptionalMiddlewareContext = createContext<OptionalMiddlewareContextProps>({})

export const getMergedOptionalMiddleware = (optionalMiddleware?: OptionalMiddlewareContextProps) => {
  return optionalMiddleware
    ? Object.values(optionalMiddleware).reduce(
        (acc, curr) => {
          if (curr.request != null) {
            acc.request.push(curr.request)
          }
          if (curr.response != null) {
            acc.response.push(curr.response)
          }
          return acc
        },
        { request: [] as OptionalMiddlewareRequest[], response: [] as OptionalMiddlewareResponse[] }
      )
    : { request: [], response: [] }
}
